import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const ProposedAddressSchema = z.object({
  street1: z.string(),
  street2: z.string().optional(),
  city: z.string(),
  state: z.string().optional(),
  postalCode: z.string(),
  country: z.string(),
});

export type ProposedAddress = z.infer<typeof ProposedAddressSchema>;

export const validateReturnsCenterAddress = unaryRpc({
  name: "validateReturnsCenterAddress" as const,
  input: z.object({
    street1: z.string().nullable(),
    street2: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    postalCode: z.string().nullable(),
    country: z.string().nullable(),
  }),
  output: z.object({
    isInternational: z.boolean(),
    success: z.boolean(),
    proposedAddress: ProposedAddressSchema.optional(),
    avc: z.string().optional(),
    error: z.string().optional(),
  }),
});
